import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Login';
import Registration from '../pages/Registration';
import Dashboard from '../pages/Dashboard';
// import DashboardRoutes from './DashboardRoutes';
import TechnicianList from '../components/TechnicianList';
import ForgotPassword from '../pages/ForgotPassword';
import ProtectedRoute from './ProtectedRoute';
import AppLayout from '../components/AppLayout';
import DeviceAnalysis from '../components/DeviceAnalysis';
import SetPassword from '../components/SetPassword';
import SuccessPage from '../components/SuccessPage';
import { useSelector } from 'react-redux';
import TermsOfService from '../components/PrivacyPolicy/TermsOfService';
import PrivacyPolicy from '../components/PrivacyPolicy/PrivacyPolicy';

function TechnicianListWrapper() {
  const [openModal, setOpenModal] = React.useState(false);
  const [editMode, setEditMode] = React.useState(false);
  // Pass this to Header via AppLayout, only opens modal on button click
  const handleAddTechnician = React.useCallback(() => setOpenModal(true), []);

  return (
    <AppLayout onAddTechnician={handleAddTechnician}>
      <TechnicianList modalOpen={openModal} setModalOpen={setOpenModal} editMode={editMode} setEditMode={setEditMode} />
    </AppLayout>
  );
}

const AppRoutes = () => {
  const user = useSelector((state) => state.auth.user);
  const role = user?.role || localStorage.getItem('role');
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Registration />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <AppLayout>
                <Dashboard />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/technicians"
          element={
            <ProtectedRoute>
              {role === 'ADMIN' ? (
                <TechnicianListWrapper />
              ) : (
                <Navigate to="/dashboard" replace />
              )}
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/device/:deviceId"
          element={
            <ProtectedRoute>
              <AppLayout>
                <DeviceAnalysis />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        <Route path="/set-technician-password" element={<SetPassword />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="*" element={<Login />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  )
};

export default AppRoutes;
